export const TELEMETRY_EVENTS = {
  SESSION_STARTED: "session.started",
  ROUTE_VIEW: "route.view",
  ROUTE_NAVIGATION: "route.navigation",
  WORKSPACE_INITIALIZED: "workspace.initialized",
  WORKSPACE_SHELL_RENDERED: "workspace.shell.rendered",
  SIDEBAR_NAVIGATION: "sidebar.navigation",
  SIDEBAR_TOGGLE: "sidebar.toggle",
  API_REQUEST_FAILED: "api.request.failed",
  APPLICATION_ERROR: "application.error",
  PERFORMANCE_MEASURE: "performance.measure",
  INPUT_MODE_PHASE_CHANGED: "workspace.input_mode.phase_changed",
  INPUT_MODE_PRIMARY_ACTION: "workspace.input_mode.primary_action",
  OUTPUT_MODE_STATE_CHANGED: "workspace.output_mode.state_changed",
  OUTPUT_MODE_ACTION: "workspace.output_mode.action",
  STICKY_ACTION_BAR_CONTEXT_CHANGED: "workspace.sticky_action_bar.context_changed",
  STICKY_ACTION_BAR_ACTION: "workspace.sticky_action_bar.action",
  WORKSPACE_SEARCH: "workspace.search",
  WORKSPACE_SEARCH_SELECT: "workspace.search.select_result",
  WORKSPACE_SEARCH_CLEAR: "workspace.search.clear",
  WORKSPACE_SECTION_RENDER: "workspace.section.render",
  WORKSPACE_SECTION_INTERACTION: "workspace.section.interaction",
  VALIDATION_FAILED: "generation.validation_failed",
  GENERATION_STARTED: "generation.started",
  GENERATION_COMPLETED: "generation.completed",
  GENERATION_FAILED: "generation.failed",
  GENERATION_REGENERATED: "generation.regenerated",
  GENERATION_VERSION_RESTORED: "generation.version_restored",
  TEACH_GUIDE_GENERATED: "teach_guide.generated",
  TEACH_GUIDE_REGENERATED: "teach_guide.regenerated",
  TEACH_GUIDE_REGENERATE_FAILED: "teach_guide.regenerate_failed",
  EXPLAIN_DIFFERENTLY_GENERATED: "explain_differently.generated",
  EXPLAIN_DIFFERENTLY_REGENERATED: "explain_differently.regenerated",
  EXPLAIN_DIFFERENTLY_REGENERATE_FAILED: "explain_differently.regenerate_failed",
  WORKSPACE_TAB_CHANGED: "workspace.tab.changed",
  EXPORT_EVENT: "export.event",
  RETRY_EVENT: "retry.event",
};

export const TELEMETRY_CATEGORIES = {
  NAVIGATION: "navigation",
  WORKSPACE: "workspace",
  INTERACTION: "interaction",
  PERFORMANCE: "performance",
  ERROR: "error",
  API: "api",
  EXPORT: "export",
  RETRY: "retry",
};
